const sortSectionList = (
  sectionList,
  sortOrder,
  isCaseListAscending,
  reviewLaterSections
) => {
  let sortedSectionList = sectionList;
  switch (sortOrder) {
    case "CaseNumber":
      sortedSectionList = [...sortedSectionList].sort((a, b) => {
        return a.sectionNumber - b.sectionNumber;
      });
      break;
    case "CompletionDate":
      sortedSectionList = [...sortedSectionList].sort((a, b) => {
        return new Date(b.LastCompletionDate) - new Date(a.LastCompletionDate);
      });
      break;
    case "ReviewLater":
      sortedSectionList = [...sortedSectionList].sort((a, b) => {
        return (
          (reviewLaterSections[b.sectionId] || 0) -
          (reviewLaterSections[a.sectionId] || 0)
        );
      });
      break;
    case "AverageGrade":
      sortedSectionList = [...sortedSectionList].sort((a, b) => {
        return a.AvgGradeForCase - b.AvgGradeForCase;
      });
      break;
    case "CaseTitle":
      sortedSectionList = [...sortedSectionList].sort((a, b) => {
        return a.sectionTitle === b.sectionTitle
          ? 0
          : a.sectionTitle < b.sectionTitle
          ? -1
          : 1;
      });
      break;
    default:
      break;
  }

  if (!isCaseListAscending) {
    sortedSectionList = [...sortedSectionList].reverse();
  }

  return sortedSectionList;
};

export default sortSectionList;
